import AxiosClient from "../../../services/axios.services";

class CapacitacionServices {
  getCapacitaciones = (params) =>
    AxiosClient.get("/api/app/On_off_bording_workflow/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getCapacitacion = (params, id) =>
    AxiosClient.get(`/api/app/On_off_bording_workflow/${id}`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getBloque = (params, id) =>
    AxiosClient.get(`/api/app/On_off_bording_bloque/${id}`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getBloqueActual = (data) =>
    AxiosClient.post(`/api/app/On_off_bording_navegacion/`, data, {
      headers: { "Content-Type": "application/json" },
    });

  getBloqueAnteriorAnterior = (params) =>
    AxiosClient.get(`/api/app/On_off_bording_navegacion_anterior/`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  enviarCorreo = (params) =>
    AxiosClient.get(`/api/app/On_off_bording_envio_correo/`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  estadoActividad = (data) =>
    AxiosClient.post(`/api/app/On_off_bording_estado/`, data, {
      headers: { "Content-Type": "application/json" },
    });

  editTarea = (id, data) =>
    AxiosClient.put(`/api/app/On_off_bording_tarea/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });

  getVentanaBienvenida = (params) =>
    AxiosClient.get("/api/app/On_off_bording_mostrar_bienvenida/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
}

export default new CapacitacionServices();
